<template>
  <div class="case-detail-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="breadcrumb">
        <span class="breadcrumb-item link" @click="goBack">案例管理</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item">{{ caseInfo.title || '案例详情' }}</span>
      </div>
    </div>

    <!-- 查看更多 -->
    <div class="view-more-section">
      <div class="images-container">
        <div v-for="(image, index) in getCaseImages()" :key="index" class="image-card">
          <img :src="getImageUrl(image)" :alt="`案例图片${index + 1}`" class="case-image">
        </div>
      </div>
      <div class="view-more" @click="viewMoreCases">
        <img src="@/assets/image/al/look1.png" alt="查看更多" class="view-more-icon">
        <span style="font-size: 18px;">查看更多</span>
      </div>
    </div>

    <div class="project-content">
      <div v-html="caseInfo.description" />

      <!-- 项目文档信息 -->
      <div v-if="caseInfo.data_table_file" class="document-info">
        <div class="document-header">
          <div class="document-icon">
            <i class="el-icon-folder" />
          </div>
          <div class="document-title">{{ caseInfo.title || '案例资料' }}.zip</div>
          <div class="document-meta">
            <span class="date">{{ caseInfo.create_time || '2025-04-08' }}</span>
            <span class="size">{{ getFileSize() }}</span>
            <span class="preview" @click="handleDownload">预览</span>
          </div>
        </div>
      </div>

      <!-- 项目效果图 -->
      <div class="project-rendering">
        <h3 class="section-title">项目效果图</h3>
        <div class="rendering-image">
          <img :src="getImageUrl(getFirstImage())" alt="项目效果图" class="project-image">
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button v-if="caseInfo.user_id" class="btn btn-consult" @click="goConsult">
          立即咨询
        </button>
        <button
          v-if="caseInfo.data_table_file"
          class="btn btn-download"
          @click="handleDownload"
        >
          {{ caseInfo.is_free === 1 ? '点击下载' : `¥${displayAmount} 购买并下载` }}
        </button>
      </div>
    </div>

    <!-- 免费弹窗 -->
    <div v-if="isConsultVisible" class="zf-modal-mask" @click.self="closeAll">
      <div class="zf-modal">
        <img class="zf-modal-close" src="@/assets/image/al/close.png" alt="关闭" @click="closeAll">
        <div class="zf-modal-title">资料下载</div>
        <div class="zf-modal-file">
          <img class="zf-file-icon" src="@/assets/image/al/bg.png" alt="文件">
          <div class="zf-file-meta">
            <div class="zf-file-name">{{ caseInfo.title || '案例资料' }}.zip</div>
            <div class="zf-file-sub">{{ caseInfo.create_time || '2025-04-08' }}&nbsp;&nbsp;{{ getFileSize() }}</div>
          </div>
        </div>
        <div class="zf-modal-tip">此案例的压缩包资料免费哦，可以直接下载~</div>
        <button class="zf-primary-btn" @click="toDownloadFromConsult">点击下载</button>
      </div>
    </div>

    <!-- 收费下载弹窗 -->
    <div v-if="isDownloadVisible" class="zf-modal-mask" @click.self="closeAll">
      <div class="zf-modal">
        <img class="zf-modal-close" src="@/assets/image/al/close.png" alt="关闭" @click="closeAll">
        <div class="zf-modal-title">资料下载</div>
        <div class="zf-modal-file">
          <img class="zf-file-icon" src="@/assets/image/al/bg.png" alt="文件">
          <div class="zf-file-meta">
            <div class="zf-file-name">国家会展中心项目工程二期(总概算表)</div>
            <div class="zf-file-sub">2025-04-08&nbsp;&nbsp;3.9MB</div>
          </div>
        </div>
        <div class="zf-form">
          <div class="zf-input">
            <span class="zf-input-prefix">￥</span>
            <input v-model="chargeAmount" disabled type="text" placeholder="请输入收费金额">
          </div>

          <!-- 支付方式选择 -->
          <div class="zf-payment-methods">
            <div class="payment-title">选择支付方式</div>
            <div class="payment-options">
              <div
                class="payment-option"
                :class="{ active: selectedPaymentMethod === 'wechat' }"
                @click="selectPaymentMethod('wechat')"
              >
                <img src="@/assets/image/al/wx.png" alt="微信">
                <span>微信支付</span>
              </div>
              <div
                class="payment-option"
                :class="{ active: selectedPaymentMethod === 'alipay' }"
                @click="selectPaymentMethod('alipay')"
              >
                <img src="@/assets/image/al/zfb.png" alt="支付宝">
                <span>支付宝</span>
              </div>
            </div>
          </div>

          <div class="zf-paybox">
            <div class="zf-qrcode" />
            <div class="zf-payinfo">
              <div class="zf-amount">应付金额：<span>¥{{ caseInfo.price || chargeAmount }}</span></div>
              <div class="zf-paytypes">
                <span v-if="selectedPaymentMethod === 'wechat'">使用微信扫码支付</span>
                <span v-else-if="selectedPaymentMethod === 'alipay'">使用支付宝扫码支付</span>
                <span v-else>请选择支付方式</span>
              </div>
              <div class="zf-agree">支付即视为您同意《智蜂智造付费协议》</div>
            </div>
          </div>
        </div>
        <button class="zf-primary-btn" style="margin-top: 10px;" @click="confirmDownload">点击下载</button>
      </div>
    </div>
    <!-- 用户评分 -->
    <div v-if="ratings && ratings.length" class="user-rating-section">
      <div class="rating-header">
        <span class="rating-label">用户评分</span>
      </div>
      <div v-for="item in ratings" :key="item.id" class="reviews-list">
        <div class="review-item">
          <div class="review-content">
            <div class="user-avatar">
              <img :src="getImageUrl(item.avatar)" alt="用户头像" class="avatar-img">
            </div>
            <div class="user-info">
              <span class="username">{{ item.username }}</span>
              <span class="review-date">{{ item.createtime }}</span>
            </div>
          </div>
          <div class="rating-stars">
            <span class="rating-score">{{ item.rating_text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCostCaseDetail } from '@/api/user'

export default {
  name: 'ProfileCaseDetail',
  data() {
    return {
      isConsultVisible: false,
      isDownloadVisible: false,
      chargeAmount: '199',
      caseInfo: {},
      ratings: [],
      selectedPaymentMethod: '' // 选择的支付方式
    }
  },
  computed: {
    displayAmount() {
      return this.caseInfo.price || this.chargeAmount
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      try {
        const id = this.$route.query.case_id
        const response = await getCostCaseDetail(id)
        if (response && response.code === 1 && response.data) {
          this.caseInfo = response.data
          this.ratings = [] // 接口返回的数据中没有ratings字段
          if (this.caseInfo && this.caseInfo.price) {
            this.chargeAmount = String(this.caseInfo.price)
          }
        }
      } catch (e) {
        console.error('获取案例详情失败:', e)
      }
    },
    viewMoreCases() {
      this.$router.push('/profile/index')
    },
    goBack() {
      this.$router.push('/profile/index')
    },
    goConsult() {
      // 从案例信息中获取用户ID
      const engineerId = this.caseInfo.user_id || 1
      this.$router.push({
        path: '/consulting/index',
        query: { cost_engineer_id: engineerId }
      })
    },
    closeAll() {
      this.isConsultVisible = false
      this.isDownloadVisible = false
    },
    toDownloadFromConsult() {
      this.isConsultVisible = false
      this.isDownloadVisible = true
    },
    async confirmDownload() {
      if (!this.selectedPaymentMethod) {
        this.$message && this.$message.warning('请选择支付方式')
        return
      }
      // 支付后下载
      await this.downloadFile()
      this.closeAll()
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method
    },
    async handleDownload() {
      if (this.caseInfo && Number(this.caseInfo.is_free) === 1) {
        // 免费直接下载
        await this.downloadFile()
      } else {
        // 收费弹出支付弹窗
        this.isDownloadVisible = true
      }
    },
    async downloadFile() {
      try {
        // 直接使用data_table_file字段作为下载链接
        if (!this.caseInfo.data_table_file) {
          this.$message && this.$message.error('暂无下载文件')
          return
        }

        // 拼接域名获取完整下载链接
        const downloadUrl = this.getImageUrl(this.caseInfo.data_table_file)

        // 创建下载链接并触发下载
        const link = document.createElement('a')
        link.href = downloadUrl

        // 设置下载文件名为压缩包格式
        const fileName = this.getDownloadFileName()
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$message && this.$message.success('开始下载压缩包...')
      } catch (error) {
        console.error('下载失败:', error)
        this.$message && this.$message.error('下载失败，请重试')
      }
    },

    // 获取文件大小
    getFileSize() {
      // 如果有文件大小信息，使用实际大小
      if (this.caseInfo.file_size) {
        return this.formatFileSize(this.caseInfo.file_size)
      }
      // 默认显示压缩包大小
      return '压缩包'
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    // 获取下载文件名
    getDownloadFileName() {
      const caseTitle = this.caseInfo.title || '案例资料'
      // 清理文件名中的特殊字符
      const cleanTitle = caseTitle.replace(/[<>:"/\\|?*]/g, '_')
      // 添加压缩包扩展名
      return `${cleanTitle}.zip`
    },
    // 获取案例图片数组
    getCaseImages() {
      if (this.caseInfo.images && Array.isArray(this.caseInfo.images)) {
        return this.caseInfo.images.slice(0, 3) // 最多显示3张图片
      }
      // 如果没有images数组，使用cover_image作为默认图片
      return this.caseInfo.cover_image ? [this.caseInfo.cover_image] : []
    },

    // 获取第一张图片
    getFirstImage() {
      const images = this.getCaseImages()
      return images.length > 0 ? images[0] : this.caseInfo.cover_image || ''
    },

    // 获取图片URL
    getImageUrl(imagePath) {
      if (!imagePath) return require('@/assets/image/logo.png')
      if (imagePath.startsWith('http')) return imagePath
      return this.$getImageUrl ? this.$getImageUrl(imagePath) : imagePath
    }
  }
}
</script>

<style lang="scss" scoped>
.case-detail-container {
	width: var(--page-wide-ratio, 75%);
  min-height: 100vh;
  padding: 20px;
  margin: 0 auto;
}

/* 弹窗样式 */
.zf-modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.zf-modal {
  position: relative;
  width: 560px;
  background: #fff;
  border-radius: 10px;
  padding: 24px 28px 28px;
}

.zf-modal-close {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.zf-modal-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.zf-modal-file {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px;
}

.zf-file-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
}

.zf-file-meta {
  display: flex;
  flex-direction: column;
}

.zf-file-name { font-size: 14px; font-weight: 600; color: #333; }
.zf-file-sub { font-size: 12px; color: #999; margin-top: 4px; }

.zf-modal-tip {
  text-align: center;
  color: #9aa0a6;
  margin: 18px 0 16px;
}

.zf-primary-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(90deg, #1677ff 0%, #1e6ce2 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.zf-form { margin-top: 8px; }

.zf-input {
  position: relative;
  height: 44px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding-left: 28px;
  margin-bottom: 14px;
}
 .zf-input-prefix { position: absolute; left: 10px; color: #999; }
 .zf-input input { flex: 1; height: 100%; border: none; outline: none; font-size: 14px; }

 .zf-payment-methods {
   margin-bottom: 14px;

   .payment-title {
     font-size: 14px;
     font-weight: 600;
     color: #333;
     margin-bottom: 10px;
   }

   .payment-options {
     display: flex;
     gap: 12px;

     .payment-option {
       flex: 1;
       display: flex;
       align-items: center;
       justify-content: center;
       gap: 8px;
       padding: 12px 16px;
       border: 1px solid #e5e6eb;
       border-radius: 6px;
       cursor: pointer;
       transition: all 0.3s ease;

       &:hover {
         border-color: #0f6fe2;
         background: #f0f8ff;
       }

       &.active {
         border-color: #0f6fe2;
         background: #f0f8ff;
         color: #0f6fe2;
       }

       img {
         width: 20px;
         height: 20px;
       }

       span {
         font-size: 14px;
         font-weight: 500;
       }
     }
   }
 }

.zf-paybox { display: flex; gap: 16px; align-items: center; }
.zf-qrcode { width: 120px; height: 120px; background: #f2f3f5; border-radius: 6px; }
.zf-payinfo { flex: 1; }
.zf-amount { margin-bottom: 8px; }
.zf-amount span { color: #f5222d; font-weight: 700; }
.zf-paytypes { display: flex; align-items: center; gap: 6px; color: #86909c; margin: 6px 0; }
.zf-paytypes img { width: 20px; height: 20px; }
.zf-agree { color: #b8b8b8; font-size: 12px; }

.breadcrumb-section {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    .breadcrumb-item {
      color: #000000;
      &.link { cursor: pointer; color: #0F70E2; }
    }

    .breadcrumb-separator {
      margin: 0 8px;
      color: #999;
    }
  }
}

.view-more-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 30px;

  .images-container {
    display: flex;
    gap: 20px;
    flex: 1;

    .image-card {
      flex: 1;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }

      .case-image {
        width: 100%;
        height: 300px;
        object-fit: cover;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .view-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    color: #0F70E2;
    font-size: 14px;
    transition: color 0.3s ease;
    min-width: 80px;
    writing-mode: vertical-rl;
    text-orientation: mixed;

    &:hover {
      color: #0c5bc7;
    }

    .view-more-icon {
      width: 20px;
      height: 20px;
      margin-bottom: 8px;
             object-fit: contain;
       margin-left: 20px;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .view-more-section {
    flex-direction: column;
    gap: 20px;

    .images-container {
      flex-direction: column;
      gap: 15px;
    }

    .view-more {
      flex-direction: row;
      gap: 8px;
      min-width: auto;
      writing-mode: horizontal-tb;
      text-orientation: mixed;

      .view-more-icon {
        margin-bottom: 0;
        margin-right: 5px;
      }
    }
  }
}

@media (max-width: 480px) {
  .case-detail-container {
    width: 95%;
    padding: 10px;
  }

  .view-more-section {
    padding: 20px;
  }
}

.project-content {
  background: #fff;
  padding: 30px;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .document-info {
    margin-bottom: 30px;

    .document-header {
      display: flex;
      align-items: center;
      gap: 15px;

      .document-icon {
        width: 40px;
        height: 40px;
        background: #4CAF50;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
      }

      .document-title {
        flex: 1;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }

      .document-meta {
        display: flex;
        gap: 15px;
        font-size: 14px;
        color: #666;

        .preview {
          color: #0F70E2;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .project-rendering {
    margin-bottom: 30px;

    .section-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
    }

    .rendering-image {
      .project-image {
        width: 100%;
        height: 300px;
        object-fit: cover;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;

    .btn {
      flex: 1;
      padding: 15px 30px;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &.btn-consult {
        background: #0F70E2;
        color: #fff;

        &:hover {
          background: #0c5bc7;
        }
      }

      &.btn-download {
        background: #F39800;
        color: #fff;

        &:hover {
          background: #F39800;
        }
      }

      i {
        font-size: 18px;
      }
    }
  }
}

.user-rating-section {
	background: #fff;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	margin-top: 20px;
    .rating-header {
      margin-bottom: 20px;

      .rating-label {
        background: #0F70E2;
        color: #fff;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .reviews-list {
      .review-item {
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .user-avatar {
          margin-right: 10px;
          .avatar-img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .review-content {
          display: flex;
          align-items: center;

          .user-info {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .username {
              font-size: 14px;
              font-weight: bold;
              color: #333;
            }

            .review-date {
              font-size: 12px;
              color: #999;
            }
          }
        }

        .rating-stars {
            display: flex;
            align-items: center;
            margin-top: 10px;

            .star-icon {
              width: 20px;
              height: 20px;
              object-fit: contain;
              margin-right: 10px;
            }

            .rating-score {
              margin-left: 10px;
              font-size: 16px;
              color: #F39800;
              font-weight: bold;
            }
          }
      }
    }
  }

// 响应式设计
@media (max-width: 768px) {
  .project-content {
    padding: 20px;

    .document-info {
      .document-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;

        .document-meta {
          flex-direction: column;
          gap: 5px;
        }
      }
    }

    .action-buttons {
      flex-direction: column;
      gap: 15px;
    }
  }
}

</style>
